<template>
  <v-container fluid fill-height class="grey lighten-3 pl-2 pr-2 pt-2">
    <v-layout row wrap>
      <v-flex xs12>
        <div class="mt-2 mb-2 ob-section-title-and-tabs">
          <h1 class="headline ob-section-title pr-4 primary--text d-flex mb-2">
            <v-avatar class="ob-no-grow-or-shrink mr-2" :class="{ 'ob-rotate': loading }" size="36">
              <img src="/img/tud_group_round_transparent.png" alt="TUD Group company logo">
            </v-avatar>
            {{ translateUI(label, lang) }}
            <v-spacer></v-spacer>
          </h1>

          <div style="display: flex; justify-items: space-between">
            <v-text-field
              v-model.number="perPage"
              type="number"
              max="50"
              min="1"
              prepend-inner-icon="mdi-page-previous-outline"
              single-line
              hide-details
              solo flat
              style="flex-grow: 1"
              class="pt-0 ob-client-search">
            </v-text-field>
          </div>

          <v-pagination
            circle
            v-model="page"
            :length="totalPages"
            v-if="totalPages"
            class="ob-client-pagination"
          ></v-pagination>
          <v-alert
            :value="true"
            type="warning"
            class="ob-no-records"
            v-else>
            {{ translateUI('NoRecords', lang) }}
          </v-alert>

          <!-- <v-progress-linear :indeterminate="true" height="2" v-show="loading"></v-progress-linear> -->
        </div>

        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex v-for="raport in filteredItems" :key="raport._id._id + raport._id.lang" xs12 sm12 md6 lg4 xl3>
              <v-card style="height: 100%;display: flex; flex-direction: column">
                <v-card-title primary-title class="pt-2" style="justify-content: center">
                  <div style="min-width: 0; text-align: center">
                    <div class="headline">
                      <v-icon class="mr-1 primary--text">{{raport.public ? 'mdi-parking' : 'mdi-file-multiple'}}</v-icon>
                      <span class="primary--text">{{ translateUI(raport._id.denumire, lang) }}</span>
                    </div>
                    <div>
                      <v-icon class="mr-1 grey--text" small>mdi-file-plus-outline</v-icon>
                      <span class="grey--text caption">{{ raport._id.createdAt | shortDate }}</span>
                      &nbsp;
                      <v-icon class="mr-1 grey--text" small>mdi-file-document-edit-outline</v-icon>
                      <span class="grey--text caption">{{ raport._id.updatedAt | shortDate }}</span>
                    </div>
                  </div>
                </v-card-title>

                <!-- <v-divider></v-divider> -->

                <v-card-text class="py-0 px-1" style="flex-grow: 1">
                  <v-subheader>
                    <span>{{ translateUI('Card_4', lang) }}</span>
                  </v-subheader>
                  <div class="px-3 body-1" style="text-align: justify">
                    {{ translateUI(raport._id.detalii, lang) }}
                  </div>
                  <!-- <div class="body-1" v-if="raport.perioade[0] !== 'null-null'"> -->
                  <div class="body-1" v-if="!raport.perioade[0].startsWith('null-null')">
                    <v-list dense class="reports-list-client">
                      <v-list-group>
                        <template v-slot:activator>
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{ translateUI('Perioade', lang) }}
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>

                        <template v-for="perioada in raport.perioade">
                          <v-list-tile :key="perioada" @click="dummy" v-if="perioada.endsWith(lang)">
                            <v-list-tile-action>
                              <v-checkbox
                                v-model="raport.selectedPerioade"
                                :value="perioada.substring(0, 7)"
                                color="accent"
                                hide-details>
                              </v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title @click="togglePerioada(raport, perioada.substring(0, 7))">
                                {{ perioada.substring(0, 7).replace('T', translateUI('TrimScurt_1', lang)) }}
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list-group>
                    </v-list>
                  </div>

                  <div v-if="user.admin && raport._id.time && raport._id.time[lang]" class="mt-2">
                    <v-list dense class="reports-list-client" v-if="!raport.perioade[0].startsWith('null-null')">
                      <v-list-group>
                        <template v-slot:activator>
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{ translateUI('Timing', lang) }}
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>

                        <template>
                          <v-list-tile v-for="(time, perioada) in raport._id.time[lang]" :key="perioada">
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{ perioada }}
                                :
                                {{ time }}
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list-group>
                    </v-list>

                    <v-list dense class="reports-list-client" v-else>
                      <v-subheader>{{ translateUI('Timing', lang) }}</v-subheader>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{ raport._id.time[lang]['null-null'] }}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :disabled="!raport.selectedPerioade.length" block color="primary" flat v-if="!raport.perioade[0].startsWith('null-null')" @click="download(raport)">
                    <template v-if="raport.selectedPerioade.length">
                      {{ translateUI('Card_10', lang) }} ({{raport.selectedPerioade.length}})
                    </template>
                    <template v-else>
                      0 {{ translateUI('Card_9', lang) }}
                    </template>
                    <v-icon right>
                      mdi-package-down
                    </v-icon>
                  </v-btn>
                  <v-btn block color="primary" flat v-else @click="download(raport)">
                    {{ translateUI('Download', lang) }}
                    <v-icon right>
                      mdi-package-down
                    </v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import translate from '@/mixins/Translate';
import streamSaver from 'streamsaver';

export default {
  name: 'rapoarte-agregate',
  components: {},
  mixins: [translate],
  data: () => ({
    type: 'agregate',
    label: 'SectiuneAgregate_Titlu'
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    items () {
      return this.$store.getters[`${this.type}/items`]
    },
    pagination () {
      return this.$store.getters[`${this.type}/pagination`]
    },
    perPage: {
      get () {
        return this.pagination.rowsPerPage
      },
      set (value) {
        const v = parseInt(value)
        if (!isNaN(v) && v > 0 && v <= 50) this.$store.dispatch(`${this.type}/setPerPage`, v)
        else this.$store.dispatch(`${this.type}/setPerPage`, 10)
      }
    },
    total () {
      return this.$store.getters[`${this.type}/total`]
    },
    totalPages () {
      if (this.total) return Math.ceil(this.total / this.pagination.rowsPerPage)
      return 0
    },
    page: {
      get () {
        return this.pagination.page
      },
      set (value) {
        const pagination = { ...this.pagination }
        pagination.page = value
        this.$store.dispatch(`${this.type}/paginationChanged`, pagination)
      }
    },
    loading () {
      return this.$store.getters[`${this.type}/loading`]
    },
    token () {
      return this.$store.getters['token']
    },
    user () {
      return this.$store.getters['user']
    },
    lang () {
      return this.$store.getters['dictionar/lang']
    },
    languages () {
      return this.$store.getters['dictionar/languages']
    },
    filteredItems () {
      return this.items.filter(item => item.langs.includes(this.lang))
    }
  },
  watch: {
    lang (v) {
      this.items.forEach((item, index) => {
        this.$set(this.items[index], 'selectedPerioade', [])
      })
    }
  },
  methods: {
    download (raport) {
      raport._id.lang = this.lang
      this.$store.commit(`${this.type}/setLoading`, true)
      // const fileStream = createWriteStream(report.zip)
      if (this.host !== 'http://localhost:3333' && this.host !== 'http://http://10.194.250.173') {
        streamSaver.mitm = `${this.host}/mitm.html`
      }
      const fileStream = streamSaver.createWriteStream(`TUDs_Analytics_${this.translate(null, raport._id.denumire)}_${raport.selectedPerioade.length || 1}_${raport.selectedPerioade.length > 1 ? this.translate('raport', 'Rapoarte') : this.translate('raport', 'Raport')}.zip`)
      fetch(`${this.host}/agg-raport`, {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': this.token
        }),
        body: JSON.stringify({ raport })
      })
        .then(res => {
          this.$store.commit(`${this.type}/setLoading`, false)

          // more optimized
          if (res.body.pipeTo) {
            return res.body.pipeTo(fileStream).then(() => console.log('done writing'))
          }

          const writer = fileStream.getWriter()
          const reader = res.body.getReader()
          const pump = () => reader.read().then(({ value, done }) => {
            if (done) {
              // close the stream so we stop writing
              writer.close()
              this.$store.commit(`${this.type}/setLoading`, false)
            } else {
              // Write one chunk, then get the next one
              writer.write(value).then(pump)
            }
          })

          // Start the reader
          pump().then(() => {
            this.$store.commit(`${this.type}/setLoading`, false)
            console.log('Closed the stream, Done writing')
          })
        })
        .catch(err => {
          this.error = true
          this.$store.commit(`${this.type}/setLoading`, false)
          console.log(err)
        })
    },

    translate (head, value) {
      switch (head) {
        case 'raport': return this.translateUI(value === 'Raport' ? 'Raport' : 'Rapoarte', this.lang)
        default: return this.translateUI(value, this.lang)
      }
    },

    togglePerioada (raport, perioada) {
      const index = raport.selectedPerioade.findIndex(p => p === perioada)

      if (index === -1) {
        raport.selectedPerioade.push(perioada)
      } else {
        raport.selectedPerioade.splice(index, 1)
      }
    },

    dummy () {}
  },
  created () {
    this.$store.dispatch(`${this.type}/setEventWatchers`)
    this.$store.dispatch(`${this.type}/fetchItems`)
  }
}
</script>

<style>

</style>
